import type { SupplierPortalRole } from '../types';
import { parseSupplierPortalRole } from './supplierWorkFlags';

/** Staff supplier-portal preview access level (URL `as=`). Defaults to owner. */
export type SupplierPortalPreviewRole = SupplierPortalRole;

export function parseSupplierPortalPreviewRole(
  raw: string | null | undefined,
): SupplierPortalPreviewRole {
  return parseSupplierPortalRole(raw);
}

/**
 * Query string for staff "view as supplier" preview.
 * Owner: `?viewAs=<orgId>`
 * Employee: `?viewAs=<orgId>&as=employee`
 */
export function buildSupplierPortalPreviewSearch(args: {
  orgId: string;
  role?: SupplierPortalPreviewRole | null;
}): string {
  const params = new URLSearchParams();
  params.set('viewAs', args.orgId.trim());
  if (parseSupplierPortalPreviewRole(args.role) === 'employee') {
    params.set('as', 'employee');
  }
  return `?${params.toString()}`;
}

/** Keep or clear `viewAs` / `as` on an existing search-params object (e.g. hub navigation). */
export function applySupplierPortalPreviewToSearchParams(
  current: URLSearchParams,
  orgId: string | null | undefined,
  role?: SupplierPortalPreviewRole | null,
): URLSearchParams {
  const next = new URLSearchParams(current);
  const id = orgId?.trim() || '';
  if (!id) {
    next.delete('viewAs');
    next.delete('as');
    return next;
  }
  next.set('viewAs', id);
  if (parseSupplierPortalPreviewRole(role) === 'employee') {
    next.set('as', 'employee');
  } else {
    next.delete('as');
  }
  return next;
}
